module.exports = __webpack_public_path__ + "img/138.8115b096.jpg";